export default __webpack_public_path__ + "static/media/logo-footer1.c98e8e15.png";